// Webpack Imports
import 'bootstrap';


( function ( $ ) {
	'use strict';

	// Focus input if Searchform is empty
	$( '.search-form' ).on( 'submit', function ( e ) {
		var search = $( this ).find( 'input' );
		if ( search.val().length < 1 ) {
			e.preventDefault();
			search.trigger( 'focus' );
		}
	} );

	// Toggle members:
	$('.team-members .btn').on('click', function()
	{
		var id = $(this).attr('data-id');
		var key = $(this).attr('data-key');
		$('#' + id).slideUp(function()
		{
			$('#' + id + '-' + key).slideDown(function()
			{
				document.getElementById(id + '-' + key).scrollIntoView({behavior: 'smooth'});
			});
		});
		return false;
	});

	// Toggle members content:
	$('.team-members-content .close').on('click', function()
	{
		var id = $(this).attr('data-id');
		$(this).parent().find('.content-item').slideUp(function()
		{
			$('#' + id).slideDown(function()
			{
				document.getElementById(id).scrollIntoView({behavior: 'smooth'});
			});
		});
		return false;
	});

	// Listen for sign up click:
	$('#menu-main-menu a').on('click', function()
	{
		// Get href:
		var href = $(this).attr('href');
		// Look for signup:
		if(href == '#sign-up')
		{
			var id = $('#main .blocks .signup').first().attr('id');
			document.getElementById(id).scrollIntoView({behavior: 'smooth'});
			return false;
		}
		return true;
	});

	// Set video bg height:
	function setVideoBgHeight()
	{
		// Look for slider:
		if($('.wp-block-eedee-block-gutenslider').length > 0)
		{
			var height = $('.wp-block-eedee-block-gutenslider').height();
			$('.video-bg').height(height);

			console.log(height);
		}
		// Look for video:
		if($('.vimeo-embed').length > 0)
		{
			var height = $('.vimeo-embed').outerHeight();
			$('.video-bg').height(height);

			console.log(height);
		}
	}
	// Set video bg height:
	if($('.video-bg').length > 0)
	{
		setVideoBgHeight();
	}

	// Set video height on resize:
	$(window).on('resize', function()
	{
	    setVideoBgHeight();
	});

}( jQuery ) );
